
import DioramaPanel from "../../lib/services/scene/diorama_panel";
import ShaderService from "../../lib/services/shader/shader_service";
import ResourceService from "../../lib/services/resource/resourceservice";
import Camera from "../../lib/services/scene/camera";
import BoxCollisionVolume from "../../lib/services/collision/box_collision_volume";
import Stage from "../../lib/services/stage/stage";
export default class Doghouse extends DioramaPanel
{

  constructor(key: string) 
  {
      super(key,"unlit_texture_alpha","doghouse",1,1);
   
      const cbox = new BoxCollisionVolume(
        0.710,0.500,0.321,   // width, height, depth
         -0.012,0.357,-0.060,   // offset x, y, z
        "nav",
        false
      );
      this.add_collision_volume(cbox);
  }

  async build(device: GPUDevice,format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
     await super.build(device,format,shader_service,resource_service);
     
    this.register_collisions(Stage.instance().collision_service);
    this.transform.set_position(0.595039963722229,-0.07502000033855438,5.636758327484131);
    this.transform.set_rotation(0, 0, 0);
    this.transform.set_scale(-0.7532042264938354,0.7532042264938354,0.7532042264938354);
    this.transform.update_matrix();
  }

  tick(delta_time: number): void 
  {
     // this.placement.tick(delta_time);
     //  this.volume_placement.tick(delta_time,0);
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
      super.prepare(device,camera);
  }

  draw(pass: GPURenderPassEncoder): void 
  {
      super.draw(pass);
  }
}